import { useAppSelector } from "hooks/reduxhooks";
import useForgeRock from "hooks/useForgeRock";
import { useCallback } from "react";
import { getCompanyProductsByUser } from "services/apis";
import { allProductTypes } from "types/enums/Products/Products";
import { companyProductsByUserResponse } from "types/GetCompanyProductsByUser/companyProductsByUser";
import { roleCheck } from "utils/User/Roles";

export const mapAPIProductsToUi = (
  associatedProduct: string,
): allProductTypes | undefined => {
  switch (associatedProduct?.toUpperCase()) {
    case "GIP": {
      return "GIP";
    }
    case "GLI": {
      return "GL";
    }
    case "GCI": {
      return "CIC";
    }
    case "GIPVRS": {
      return "REHAB";
    }
    default: {
      return undefined;
    }
  }
};

const useGetCompanyProductsByUser = () => {
  const { APICall } = useForgeRock();
  const user = useAppSelector((state) => state.userSlice);

  const companyProductsByUser = useCallback(async (): Promise<
    allProductTypes[]
  > => {
    let availableProducts: allProductTypes[] = [];
    if (roleCheck(user.role, ["cashplan"])) {
      availableProducts = ["cashPlan"];
    }

    try {
      const response: companyProductsByUserResponse = await APICall(
        getCompanyProductsByUser(),
      );
      if (
        response?.resultCode === -1 ||
        response?.response?.associatedProducts?.length === 0
      ) {
        return availableProducts;
      }

      const products = response.response.associatedProducts
        .map((product) => mapAPIProductsToUi(product))
        .filter((prod) => prod !== undefined);

      return [...products, ...availableProducts];
    } catch {
      return availableProducts;
    }
  }, []);

  return { companyProductsByUser };
};

export default useGetCompanyProductsByUser;
